import React from "react";
import ScreenThreeComp from "./ScreenThreeComp";
import close from "../images/Icon (2).svg";
import { showSwalPopup } from "../../notes/actions/ShowSwalPopup";
import { withRouter } from "react-router-dom";
import ScreenTwoCompNew from "./ScreenTwoCompNew";

const PaymentGatewayComp = (props) => {
   const {
      updateStripeStatus = () => {},
      step,
      setStep,
      fromStartSubscription,
      setFromStartSubscription,
      isNeedMoreTime,
   } = props;

   const navigateFun = () => {
      window.location.href = "/notes";
   };
   const startSubscriptionFun = () => {
      setStep(2);
      setFromStartSubscription(true); // Track that this function was invoked
   };
   const closeIconFun = () => {
      if (step === 2) {
         if (!fromStartSubscription) {
            navigateFun();
         } else if (isNeedMoreTime) {
            setStep(3);
         } else {
            setStep(4);
         }
      } else if (step === 3) {
         showSwalPopup(
            "Need some more time?",
            "Get two more days of Playback Pro - on us!",
            "Confirm",
            "Confirm",
            "No Thanks",
            () => {
               updateStripeStatus();
            },
            () => {
               navigateFun();
            },
            false,
            false,
            false,
            false,
            true,
            true
         );
      } else {
         navigateFun();
      }
   };

   const handleContactFun = () => {
      window.open("/contact-sales", "_blank");
   };

   return (
      <div className="pg-center-aline-container-new-ui d-relative">
         <div className="trial-new-flow-background-payment-link" />
         <img className="pg-close-icon-container-new-ui pointer" src={close} alt="close" onClick={closeIconFun} />
         {step === 2 && <ScreenTwoCompNew {...props} step={step} />}
         {step === 3 && (
            <ScreenThreeComp
               onClick={startSubscriptionFun}
               updateStripeStatus={updateStripeStatus}
               {...props}
               isStepthree={3}
               navigateFun={navigateFun}
            />
         )}
         {step === 4 && (
            <ScreenThreeComp
               onClick={startSubscriptionFun}
               handleContactFun={handleContactFun}
               {...props}
               isStepFour={4}
            />
         )}
      </div>
   );
};

export default withRouter(PaymentGatewayComp);
